const TableData = [
    {
        id: '1',
        frontsymbol: '$',
        amount: '368.24',
        title: 'Annual Profit',
        symbol: 'M',
        rate: '4.65',
        color: 'success',
        icon: 'briefcase',
        iconcolor: 'primary',
        arrowicon: 'arrow-up',
        rangevalue: 76
    },
    {
        id: '2',
        frontsymbol: '$',
        amount: '1454.71',
        title: 'Daily average income',
        symbol: 'k',
        rate: '1.33',
        color: 'success',
        icon: 'wallet',
        iconcolor: 'secondary',
        arrowicon: 'arrow-up',
        rangevalue: 88
    },
    {
        id: '3',
        amount: '33.37',
        title: 'Lead Conversations',
        symbol: '%',
        rate: '2.69',
        color: 'success',
        icon: 'broadcast',
        iconcolor: 'danger',
        arrowicon: 'arrow-up',
        rangevalue: 18
    },
    {
        id: '4',
        amount: '648',
        title: 'Campaign Sent',
        rate: '0.78',
        color: 'danger',
        icon: 'rocket-launch',
        iconcolor: 'success',
        arrowicon: 'arrow-down',
        rangevalue: 49
    },
    {
        id: '5',
        amount: '1742',
        title: 'Annual Deals',
        rate: '7.93',
        color: 'success',
        icon: 'heartbeat',
        iconcolor: 'warning',
        arrowicon: 'arrow-up',
        rangevalue: 83
    },
]

const leadData = [
    {
        id: '1',
        img: 'assets/images/users/48/avatar-2.jpg',
        name: 'Buck Roberts',
        phone: '(11) 3885-1022',
        score: '234',
        location: 'Guarulhos, Brazil',
        date: '17 Mar, 2023'
    },
    {
        id: '2',
        img: 'assets/images/users/avatar-3.jpg',
        name: 'Josefa Weissnat',
        phone: '(53) 3035-3100',
        score: '418',
        location: 'California, USA',
        date: '15 Mar, 2023'
    },
    {
        id: '3',
        img: 'assets/images/users/avatar-5.jpg',
        name: 'Jacinthe Will',
        phone: '(33) 3521-6761',
        score: '357',
        location: 'Brasília, Brazil',
        date: '11 Mar, 2023'
    },
    {
        id: '4',
        img: 'assets/images/users/48/avatar-6.jpg',
        name: 'Donnell Schultz',
        phone: '(51) 3233-7909',
        score: '631',
        location: 'Natal, Brazil',
        date: '29 Feb, 2023'
    },
    {
        id: '5',
        img: 'assets/images/users/48/avatar-7.jpg',
        name: 'Xander Wyman',
        phone: '(48) 3877-9000',
        score: '249',
        location: 'Logrono, Spain',
        date: '24 Feb, 2023'
    },
    {
        id: '6',
        img: 'assets/images/users/48/avatar-8.jpg',
        name: 'Buck Roberts',
        phone: '(92) 3639-8685',
        score: '176',
        location: 'Ibiza, Spain',
        date: '27 Jan, 2023'
    },
    {
        id: '7',
        img: 'assets/images/users/48/avatar-9.jpg',
        name: 'Federico Hand',
        phone: '(11) 3666-9716',
        score: '176',
        location: 'San Luis Potosi, Mexico',
        date: '21 Dec, 2022'
    }
]

const dealData = [
    {
        id: '1',
        img: 'assets/images/users/48/avatar-10.jpg',
        title: 'SASS app workflow diagram',
        subtitle: 'Closing Deal date 14 Jan, 2023',
        price: '$49.99'
    },
    {
        id: '2',
        img: 'assets/images/users/48/avatar-9.jpg',
        title: 'KooraStars - Admin Dashboard',
        subtitle: 'Closing Deal date 22 April, 2023',
        price: '$132.94'
    },
    {
        id: '3',
        img: 'assets/images/users/48/avatar-8.jpg',
        title: 'Create New Components',
        subtitle: 'Closing Deal date 29 April, 2023',
        price: '$349.99'
    },
    {
        id: '4',
        img: 'assets/images/users/48/avatar-7.jpg',
        title: 'New Email Design Templates',
        subtitle: 'Closing Deal date 23 March, 2023',
        price: '$258.73'
    },
    {
        id: '5',
        img: 'assets/images/users/48/avatar-6.jpg',
        title: 'Urban Modern Design',
        subtitle: 'Closing Deal date 17 March, 2023',
        price: '$374.61'
    },
    {
        id: '6',
        img: 'assets/images/users/48/avatar-4.jpg',
        title: 'Airbnb React Development',
        subtitle: 'Closing Deal date 03 Feb, 2023',
        price: '$976.07'
    }
]

const taskData = [
    {
        id: '1',
        title: 'Review and make sure nothing slips through cracks',
        content: 'If someone cracks, they lose control of their emotions or actions because they are under a lot of pressure.',
        date: '15 Sep, 2023'
    },
    {
        id: '2',
        title: 'Send meeting invites for sales campaign',
        content: 'I will send you a meeting invite" is grammatically incorrect. Invite is a verb and invitation is the noun.',
        date: '20 Sep, 2023'
    },
    {
        id: '3',
        title: 'Make a creating an account profile',
        content: 'Like any other essay, a profile essay has three main parts, the introduction, body, and conclusion.',
        date: '08 Feb, 2023'
    },
    {
        id: '4',
        title: 'Change email option process',
        content: "If people have you saved as something else in their contacts, that's the name they'll see.",
        date: '19 Jan, 2023'
    },
    {
        id: '5',
        title: 'Additional Calendar',
        content: 'Employees can use shared calendars to manage their own assignments and appointments',
        date: '03 Jan, 2023'
    },
]

export { TableData, leadData, dealData, taskData }